import minerCalculator from '@/api/minerCalculator'

// initial state
const state = {
    bindData:
    {
        manufacturerList: [],
        minerList: [],
        difficulty: 0,
        pps: 0,
        emissionFactorList: [],
        co2:0
    },
    requestData:{
        HP: 0,
        P: 0,
        PUE: 1.1,
        EF: 0,
        pps: 0,
    }
}


// getters
const getters = {

}

// actions
const actions = {
    getManufacturerList({ commit }, request) {
        minerCalculator.getManufacturerList(response => {
            commit('setManufacturerList', response.manufacturerList);
        }, request)
    },
    getMinerListByManufacturerId({ commit }, request) {
        minerCalculator.getMinerListByManufacturerId(response => {
            commit('setMinerList', response.minerList);
        }, request)
    },
    getDifficultyByDate({ commit }, request) {
        minerCalculator.getDifficultyByDate(response => {
            commit('setDifficulty', response.difficulty);
        }, request)
    },
    getPPSByDate({ commit }, request) {
        minerCalculator.getPPSByDate(response => {
            commit('setPPS', response.pps);
        }, request)
    },
    getEmissionFactorListByYear({ commit }, request) {
        minerCalculator.getEmissionFactorListByYear(response => {
            commit('setEmissionFactorList', response.emissionFactorList);
        }, request)
    },
    calculate({ commit }, request)
    {
        
        minerCalculator.calculate(response => {
            commit('setCo2', response.co2);
        }, request)
    }
}



// mutations
const mutations = {
    setManufacturerList(state, manufacturerList) {
        state.bindData.manufacturerList = manufacturerList
    },
    setMinerList(state, minerList) {
        state.bindData.minerList = minerList
    },
    setDifficulty(state, difficulty) {
        state.bindData.difficulty = difficulty
    },
    setPPS(state, pps) {
        state.requestData.pps = pps
    },
    setEmissionFactorList(state, emissionFactorList) {
        state.bindData.emissionFactorList = emissionFactorList
    },
    setCo2(state, co2) {
        state.bindData.co2 = co2
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
